module.exports = __webpack_public_path__ + "static/images/generic.18EH39O.svg";